export enum RemovalTransactionType {
  // None = 0,
  NlaRemoved = 1,
  XoReceiving = 2,
  RnReceiving = 3,
  ExReceiving = 4,
}

export const RemovalTransactionTypeChoices = [
  // { Description: "None", Value: RemovalTransactionType.None },
  { Description: "N/L/A REMOVED", Value: RemovalTransactionType.NlaRemoved },
  { Description: "XO/RECEIVING", Value: RemovalTransactionType.XoReceiving },
  { Description: "RN/RECEIVING", Value: RemovalTransactionType.RnReceiving },
  { Description: "EX/RECEIVING", Value: RemovalTransactionType.ExReceiving },
];
